import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router'
import { Spin } from 'antd'
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx'

const SubmitInvoicePage = lazy(() => import('./ai-extraction/submit-invoice-page.tsx'))
const InvoiceDraftsPage = lazy(() => import('./invoice-drafts/index.tsx'))
const InvoicesPage = lazy(() => import('./invoices/index.tsx'))
const CostAllocationReportsPage = lazy(
  () => import('./cost-allocation-reports/index.tsx'),
)
const InvoiceDraftItemPage = lazy(() => import('./invoice-drafts/invoice-draft-item-page.tsx'))
const CostAllocationResultPage = lazy(() => import('./invoices/cost-allocation-result-page.tsx'))
const ProductSubscriptionPage = lazy(() => import('./product-subscriptions/product-subscription-page.tsx'))
const FundAumPage = lazy(() => import('./fund-aum/fund-aum-page.tsx'))

export const invoicesAllocationRoutes: RouteObject = {
  path: 'invoices-allocation',
  element: (
    <ProtectedRoutes
      anyOfPermissions={[
        { moduleName: 'invoice-allocation', functionName: 'manage-invoice-details' },
        { moduleName: 'invoice-allocation', functionName: 'read-invoice-details' },
      ]}
    />
  ),
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spin />}>
          <SubmitInvoicePage />
        </Suspense>
      ),
    },
    {
      path: 'invoice-drafts',
      element: (
        <Suspense fallback={<Spin />}>
          <InvoiceDraftsPage />
        </Suspense>
      ),
    },
    {
      path: 'cost-allocation-reports',
      element: (
        <Suspense fallback={<Spin size="large" />}>
          <CostAllocationReportsPage />
        </Suspense>
      ),
    },
    {
      path: 'product-subscription-management',
      element: (
        <Suspense fallback={<Spin size="large" />}>
          <ProductSubscriptionPage />
        </Suspense>
      ),
    },
    {
      path: 'fund-aum',
      element: (
        <Suspense fallback={<Spin size="large" />}>
          <FundAumPage />
        </Suspense>
      ),
    },
    {
      path: 'invoices',
      element: (
        <Suspense fallback={<Spin />}>
          <InvoicesPage />
        </Suspense>
      ),
    },
    { path: 'invoice-draft-item', element: <Suspense fallback={<Spin />}><InvoiceDraftItemPage /></Suspense> },
    { path: 'cost-allocation-result', element: <Suspense fallback={<Spin />}><CostAllocationResultPage /></Suspense> },
  ],
}